import { gql } from "urql";
export const GetReferralCountQuery = gql `
    query GetReferralCount(
        $archived: Boolean!
        $search: String
        $therapyCategoryIds: [String]
    ) {
        priorityReferrals {
            priorityReferralCount(
                archived: $archived
                search: $search
                therapyCategoryIds: $therapyCategoryIds
            )
        }
    }
`;
export const GetReferralCountForTherapproveAdminsQuery = gql `
    query GetReferralCountForTherapproveAdmins($search: String) {
        priorityReferrals {
            priorityReferralCountForTherapproveAdmins(search: $search)
        }
    }
`;
export const GetReferralsQuery = gql `
    query GetReferrals(
        $archived: Boolean!
        $search: String
        $offset: Int
        $therapyCategoryIds: [String]
    ) {
        priorityReferrals {
            priorityReferrals(
                archived: $archived
                search: $search
                offset: $offset
                therapyCategoryIds: $therapyCategoryIds
            ) {
                priorityReferralId
                caregiver {
                    userId
                    firstName
                    lastName
                    email
                    phoneNumber
                }
                patient {
                    patientId
                    firstName
                    lastName
                    dateOfBirth
                    postalCode
                    postalCodeInfo {
                        city
                        stateId
                        postalCode
                    }
                }
                therapyCategory {
                    therapyCategoryId
                    name
                }
                archivedAt
                createdAt
            }
        }
    }
`;
export const GetReferralsForTherapproveAdminsQuery = gql `
    query GetReferralsForTherapproveAdmins(
        $search: String
        $offset: Int
    ) {
        priorityReferrals {
            priorityReferralsForTherapproveAdmins(
                search: $search
                offset: $offset
            ) {
                priorityReferralId
                originatingUser {
                    userId
                    name
                    email
                }
                originatingOrganization {
                    organizationId
                    name
                    imageUrl
                }
                referralRecipientEmail
                referralRecipientOrganization {
                    organizationId
                    name
                    imageUrl
                }
                priorityReferralAction
                caregiver {
                    userId
                    firstName
                    lastName
                    email
                    phoneNumber
                    acceptedTermsConditionsAt
                }
                patient {
                    patientId
                    firstName
                    lastName
                }
                archivedAt
                updatedAt
                createdAt
            }
        }
    }
`;
